<template>
  <Menu as="div" :class="classes">
    <slot name="button">
      <MenuButton
        :class="[
          iconButton
            ? 'inline-flex items-center justify-center w-6 h-6 text-gray-500 rounded-full hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue'
            : 'inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-brand-blue'
        ]">
        <template v-if="iconButton">
          <component :is="icon" :class="iconClasses" aria-hidden="true" />
        </template>
        <template v-else>
          {{ name }}
          <component :is="icon" class="w-5 h-5 mt-1 mr-3 -ml-1" aria-hidden="true" />
        </template>
      </MenuButton>
    </slot>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <slot name="content">
        <MenuItems
          as="ul"
          :class="dropdownClass"
          class="absolute right-0 z-50 min-w-fit w-64 mx-3 mt-1 origin-top-right bg-white rounded-md shadow-lg dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div @keydown.space.stop @keyup.space.stop @keypress.space.stop>
            <slot name="header" />
          </div>
          <template v-for="item in items.filter((item) => !item.hidden)" :key="item.name">
            <!-- Separator item -->
            <div v-if="item.isSeparator" :class="item.class || 'border-t border-gray-200 my-1'" />
            
            <!-- Regular menu item -->
            <MenuItem v-else v-slot="{ active }" class="flex w-full group" as="li">
              <button
                type="button"
                :class="[active ? `${item.activeClass || itemActiveClass}` : '', item.class || itemClass]"
                :disabled="item.disabled"
                @click="item.action">
                <component :is="item.icon" v-if="item.icon && !itemsCssIcons" class="w-5 h-5 mr-3" aria-hidden="true" />
                <span v-else-if="item.icon && itemsCssIcons" :class="`w-5 h-5 mr-3 ${item.icon}`" aria-hidden="true" />
                {{ item.name }}
              </button>
            </MenuItem>
          </template>
          <div @keydown.space.stop @keyup.space.stop @keypress.space.stop>
            <slot name="footer" />
          </div>
        </MenuItems>
      </slot>
    </transition>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { Lightbulb } from "lucide-vue-next"

export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Lightbulb
  },
  props: {
    name: String,
    classes: {
      type: String,
      default: "relative inline-block text-left"
    },
    itemActiveClass: {
      type: String,
      default: "bg-blue text-white"
    },
    itemClass: {
      type: String,
      default: "flex items-center w-full px-4 py-2"
    },
    dropdownClass: {
      type: String,
      default: "max-h-[400px] overflow-y-auto"
    },
    icon: {
      type: [Object, Function],
      default: () => Lightbulb
    },
    items: {
      type: Array,
      required: true
    },
    iconButton: {
      type: Boolean,
      default: false
    },
    iconClasses: {
      type: String,
      default: "w-5 h-5"
    },
    itemsCssIcons: {
      type: Boolean,
      default: false
    }
  }
}
</script>
